import { Provider } from '@vgtv/api-client';

export const countryMap: Record<string, string[]> = {
  no: [
    Provider.VGTV,
    Provider.AP,
    Provider.BT,
    Provider.E24,
    Provider.SA,
    'brandstudio',
  ],
  se: [Provider.AB, Provider.SVD],
};
